import { axiosInstance } from "../../../helper"
import { user } from "../types"

export function getProfile(params, config) {
	return {
		type: user.GET_PROFILE,
		payload: new axiosInstance.get(`/user-profile`, {
			...config,
			params,
		}),
	}
}

export default getProfile
